import axios from "axios";

const CONFIGURED_URL = process.env.REACT_APP_BACKEND_URL;
// On a custom domain (e.g. psalm30-2chiropractic.com) call the API on the same domain to avoid cross-origin blocks.
const useSameOrigin = typeof window !== "undefined" && window.location.hostname !== "localhost"
  && new URL(CONFIGURED_URL).host !== window.location.host;
export const BACKEND_URL = useSameOrigin ? window.location.origin : CONFIGURED_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function resolveImg(url) {
  if (!url) return "";
  if (url.startsWith("/api")) return `${BACKEND_URL}${url}`;
  return url;
}

export function track(type, label, path) {
  // Fire-and-forget; never let a failed/blocked analytics call surface as an unhandled rejection.
  try {
    api
      .post("/analytics/event", { type, label, path: path || window.location.pathname })
      .catch(() => {});
  } catch (e) {
    // Analytics is non-blocking; log at debug level for diagnostics without surfacing to users.
    if (process.env.NODE_ENV !== "production") console.debug("analytics track skipped:", e);
  }
}
